export const OPEN_SELLER_MODAL = 'open-seller-modal'

/**
 * Name of the hook used in elemts that open the SellerModal for a given sellerId
 * @param {*} sellerId the seller's id in mirakl
 */
export const getSellerModalHook = sellerId =>
  `${OPEN_SELLER_MODAL}--${sellerId}`
